import { groupValidationErrors, isValid } from 'buzz_lib_shared';

/**
 * Performs validation calls and maps the output into a format that is recognised by Formik.
 * If validatedFunc is supplied, it is called with a copy of the valid data.
 * @export
 * @template TDataModel
 * @template TFormModel
 * @param {TDataModel} data
 * @param {ValidateFunction<TDataModel>} validFunc
 * @param {(values: TDataModel) => void} [validatedFunc]
 * @returns
 */
export function formikValidationAdapter(data, validFunc, validatedFunc) {
  const dataIsValid = isValid(validFunc, data);
  if (dataIsValid) {
    if (validatedFunc) {
      validatedFunc(data);
    }
    return true;
  }
  return groupValidationErrors(validFunc.errors);
}